import axios from "axios";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import LogsUsuario from "./LogsAlteracaoEAcesso.js";
import BlueButton from "../../../ui/BlueButton.js";
import GreenButton from "../../../ui/GreenButton.js";

const FormContainer = styled.form`
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 0 auto; 
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
  }

`;

const DivGeral = styled.form`
  width: 800px;
  background-color: #fff;
  padding: 10px;
  flex-direction: row;
  box-shadow: 0px 0px 2px #ccc;
  margin: 5px; 
  border-radius: 8px;
`;

const Div = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const Div4 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Div6 = styled.div`
  width: 800px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap; /* permite que quebre para próxima linha */
  justify-content: center;
  align-items: center;
  gap: 1rem; /* opcional: espaço entre os itens */

  @media (max-width: 768px) {
    flex-direction: column;
    flex-wrap: nowrap; /* opcional: força coluna fixa no mobile */
  }
`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;

  select {
    width: 150px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }
`;

const Input = styled.input`
  width: 300px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;

  
`;

const Label = styled.label`
  color: #575757;
  font-weight: 600;
  font-size: 17px;  
`;




const Div2 = styled.td`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  margin: auto;
`;




const Form = ({ urlApi, editarUsuario, acessos, modulos, fetchUsuarios }) => {
  // tokens
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');


  //-----------------------------------------PREENCHE O FORM COM DADOS DOS USUÀRIOS--------------------------//

  const [usuario, setUsuario] = useState({
    COD_FUNCIONARIO: "",
    LOGON: "",
    EMAIL: "",
    NOME: "",
  });
  useEffect(() => {
    setUsuario(editarUsuario);
  }, [editarUsuario])



  //-----------------------------------------SELECT DA PROP MODULOS-----------------------------------------//
  const [acessosUsuario, setAcessosUsuario] = useState({});

  useEffect(() => {
    if (acessos.length && modulos.length) {
      const valoresIniciais = {};

      modulos.forEach((mod) => {
        const acessoUsuario = acessos.find((a) => a.COD_MODULO === mod.COD_MODULO);
        valoresIniciais[mod.COD_MODULO] = acessoUsuario ? acessoUsuario.TIPO_ACESSO : '';
      });

      setAcessosUsuario(valoresIniciais);
    }
  }, [acessos, modulos, editarUsuario]);


  const payload = {
    cod_funcionario: editarUsuario.COD_FUNCIONARIO,
    email: usuario.EMAIL.trim(),
    acessos: Object.entries(acessosUsuario).map(([cod_modulo, tipo_acesso]) => ({
      cod_modulo: parseInt(cod_modulo),
      tipo_acesso,
    })),
  };



  //-----------------------------------------FUNÇÂO QUE SALVA OS ACESSOS-----------------------------------------//

  const handleAcessos = async () => {

    try {
      await axios.post(`${urlApi}portal/salvar-acessos`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUsuarios();
      toast.success("Alteração salva com sucesso!");
      await logEvento(id, `Alterou o usuário ${usuario.COD_FUNCIONARIO}-${usuario.LOGON}`);
    } catch (error) {
      console.error('Erro ao salvar acessos:', error);
      await logEvento(id, `Erro ao alterar o usuário ${usuario.COD_FUNCIONARIO}-${usuario.LOGON}`);
    }
  };

  //-----------------------------------------FUNÇÂO QUE RESETA A SENHA--------------------------//

  const handleResetaSenha = async () => {
    if (!editarUsuario.EMAIL) {
      toast.error("È necessário cadastrar o email do usuário!");
    }
    try {
      const response = await axios.post(`${urlApi}portal/enviar-email`, {
        cod_funcionario: editarUsuario.COD_FUNCIONARIO,
        email: editarUsuario.EMAIL
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Aqui já vem como JSON automaticamente no Axios
      const data = response.data;

      toast.success(data.mensagem || "Senha resetada com sucesso!");
      await logEvento(id, `Resetou a senha do usuário ${usuario.COD_FUNCIONARIO}-${usuario.LOGON}`);

    } catch (error) {
      console.error("Erro ao resetar a senha:", error);
      await logEvento(id, `Erro ao resetar a senha do usuário ${usuario.COD_FUNCIONARIO}-${usuario.LOGON}`);

      if (error.response) {
        // Erro com resposta do servidor
        toast.error(error.response.data?.error || "Erro ao resetar a senha.");
      } else {
        // Erro de rede ou outro erro inesperado
        toast.error("Erro de rede ou erro desconhecido");
      }

    }
  };


  //---------------------------------------SALVANDO LOG DE ALTERACAO---------------------------------------------------------------//

  // Passa o logs para serem salvos no banco
  const logEvento = async (id, descricao) => {
    try {
      const logData = {
        COD_FUNCIONARIO: id,
        DESC_LOG: descricao,
      };

      const response = await fetch(`${urlApi}portal/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(logData),
      });

      if (!response.ok) {
        throw new Error('Failed to save log');
      }
    } catch (error) {
      console.error('Erro ao salvar log:', error);
    }
  };

  //---------------------------------------SALVANDO LOG DE ALTERACAO---------------------------------------------------------------//

  //Pesquisa os dados do cracha/login no banco de dados
  const [logsUsuario, setLogsUsuario] = useState([])


  const handleSearch = async () => {
    if (!editarUsuario?.COD_FUNCIONARIO) {
      return;
    }

    const payload = {
      cracha: editarUsuario.COD_FUNCIONARIO
    };

    try {
      const res = await axios.post(`${urlApi}portal/consulta-logs-usuario`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setLogsUsuario(res.data);
    } catch (error) {

      setLogsUsuario([]); // limpa se erro
    }
  };

  // Chama ao carregar ou quando editarUsuario mudar
  useEffect(() => {
    handleSearch();
  }, [editarUsuario]);
  return (
    <>
      <FormContainer>
        <DivGeral>
          <Div>

            <Div2>
              <InputArea>
                <Label>Crachá:</Label>
                <Input
                  name="cracha"
                  type="text"
                  value={usuario.COD_FUNCIONARIO}

                  disabled
                />
              </InputArea>
            </Div2>

            <Div2>
              <InputArea>
                <Label>Logon:</Label>
                <Input
                  name="logon"
                  type="text"
                  value={usuario.LOGON}
                  disabled
                  onChange={(e) =>
                    setUsuario({ ...usuario, LOGON: e.target.value })
                  }
                />
              </InputArea>
            </Div2>





          </Div>

          <Div>


            <Div2>
              <InputArea>
                <Label>Nome:</Label>
                <Input
                  name="nome"
                  type="text"
                  value={usuario.NOME}
                  disabled
                  onChange={(e) =>
                    setUsuario({ ...usuario, NOME: e.target.value })
                  }
                />
              </InputArea>
            </Div2>

            <Div2>
              <InputArea>
                <Label>Email:</Label>
                <Input
                  name="email"
                  type="email"
                  value={usuario.EMAIL}
                  onChange={(e) =>
                    setUsuario({ ...usuario, EMAIL: e.target.value })
                  }
                />
              </InputArea>
            </Div2>



          </Div>
          <Div4>
            <Div6>
              {modulos.map((modulo) => (
                <InputArea key={modulo.COD_MODULO}>
                  <Label>{modulo.DESC_MODULO}:</Label>
                  <select
                    value={acessosUsuario[modulo.COD_MODULO] || ''}
                    onChange={(e) =>
                      setAcessosUsuario({
                        ...acessosUsuario,
                        [modulo.COD_MODULO]: e.target.value,
                      })
                    }
                  >
                    <option value="">Selecione...</option>
                    <option value="A">Admin</option>
                    <option value="G">Gestor</option>
                    <option value="S">Usuário</option>
                    <option value="N">Sem Acesso</option>
                  </select>
                </InputArea>
              ))}
            </Div6>


          </Div4>
          <Div4>
            <Div2>
              <InputArea>
                <BlueButton title="Reseta a senha" type="button" onClick={handleResetaSenha}>
                  Resetar a senha
                </BlueButton>
              </InputArea>
            </Div2>

            <Div2>
              <InputArea>
                <GreenButton title="Salvar" type="button" onClick={handleAcessos}>
                  Salvar Alterações
                </GreenButton>
              </InputArea>
            </Div2>
          </Div4>

        </DivGeral>
        <LogsUsuario
          logsUsuario={logsUsuario}
        />
      </FormContainer>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>

    </>
  );
};

export default Form;


